<template>
  <div id="app">
    <component v-bind:is="layout"></component>
  </div>
</template>

<script>

import AppLayout from "./layouts/AppLayout";
import CleanLayout from "./layouts/CleanLayout";
import HandHeldLayout from "./layouts/HandHeldLayout";

export default {
  computed: {
    layout() {
      return this.$store.getters.layout;
    }
  },
  components: {
    "app-layout": AppLayout,
    "clean-layout": CleanLayout,
    'hh-layout': HandHeldLayout,
  }
};

</script>

<style>
a {
  cursor: pointer !important;
}
#nprogress {
  top: 0;
  left: 0;
  pointer-events:fill !important;
}
#nprogress .spinner {
  height: 100%;
  top: 5px !important;
  left: 0;
  width: 100%;
}

#nprogress  .spinner .container-fluid{
  background-color: #f2f2f2 !important;
}

.v-select .dropdown-toggle::after {
  display: none;
}
.card-title{
  padding-bottom: 0px !important;
}

/* Estilo para vue-select con imagen */
.v-select img {
  max-height: 3rem;
  width: auto;
  margin-right: 1rem;
}

.v-select .d-center {
  display: flex;
  align-items: center;
}

.v-select .selected img {
  max-height: 1.7rem !important;
  width: auto;
  margin-right: 0.5rem;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 10px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}
/* Vue DatePicker */
.vdp-datepicker .form-control[readonly]{
  background-color: #FFF !important;
}

.dropdown-menu button{
  cursor: pointer;
}
.table-hover tr td{
  cursor: pointer;
}
.support-index .st-meta {
    z-index: 95 !important;
}
@media (min-width: 1025px) {
  .content-w{
      min-height: 1055px !important;
  }
  .menu-w{
    
      z-index: 100;
      position: relative !important;
  }
}

.tableFixHead          { overflow: auto; min-height: 400px; max-height: 500px; }
.tableFixHead thead th { position: sticky; top: 0; z-index: 1; }

/* Just common table stuff. Really. */
.tableFixHead table  { border-collapse: collapse; width: 100%; }
.tableFixHead th, td { padding: 8px 16px; }
.tableFixHead th     { background:#eee; }
</style>